import React from 'react';
import MembershipCheckoutWidget from '../components/MembershipCheckoutWidget';

const MembershipCheckoutWidgetApp = (props) => (
  <MembershipCheckoutWidget {...props} />
);

export default MembershipCheckoutWidgetApp;
